export const general = {
	label: "Reporte general",
	eventDate: "Fecha del evento",
	filters: {
		table: "Mesa",
		employeeName: "Mesero",
		payment: "Pago",
		tablePlaceholder: "Seleccione una mesa",
		employeeNamePlaceholder: "Todos",
		status: "Estado",
		paymentPlaceholder: "Todos",
		dateOrPeriod: "Fecha o período",
	},
	resume: {
		people: "Personas",
		totalRevenue: "Facturación total",
		openTables: "Mesas en uso",
		tablesUsed: "Mesas Utilizadas",
		chargeback: "Reembolsados",
		averageTicket: "Ticket promedio",
		averageLengthStay: "Tiempo Promedio de Permanencia",
		hours: "horas y",
		minutes: "minutos",
		info: "Este valor ya incluye la tarifa de servicio.",
	},
	table: {
		title: "Consumo de mesas",
		allPayments: "Ver todos los pagos",
		columns: {
			tableName: "MESA",
			employeeName: "MESERO",
			numberOfSeats: "PERSONAS",
			permanence: "PERMANENCIA",
			checkoutBy: "CERRADA POR",
			tip: "SERVICIO",
			productsValue: "PRODUCTOS",
			openedAt: "APERTURA",
			closedAt: "CIERRE",
			discount: "DESCUENTOS",
			refundValue: "REEMBOLSOS",
			totalValue: "TOTAL",
			icon: "CUENTA",
			buyers: {
				name: "NOMBRE",
				document: "RFC",
				paymentType: "PAGO",
				total: "TOTAL",
			},
		},
	},
	paymentTypes: {
		CreditCard: "Crédito",
		DebitCard: "Débito",
		Pix: "Pix",
		Cash: "Efectivo",
	},
};
